!(function () {
  "use strict";
  customElements.get("collection-filters") ||
    customElements.define(
      "collection-filters",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.sortDropdownEvent = () => this.sortDropdownToggle()),
            (this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
            (this.updateCollectionFormSortEvent = (t) =>
              this.updateCollectionFormSort(t)),
            (this.bodyClickEvent = (t) => this.bodyClick(t)),
            (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
            (this.onFilterTagResetClick =
              this.onFilterTagResetClick.bind(this)),
            (this.onFilterTagClearClick =
              this.onFilterTagClearClick.bind(this)),
            (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
            (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
            (this.updateRangeEvent = this.updateRange.bind(this)),
            (this.onHistoryChangeBound = this.onHistoryChange.bind(this)),
            (this.debouncedSubmitEvent = window.theme.debounce((t) => {
              this.onSubmitHandler(t);
            }, 500)),
            (this.debouncedSortEvent = window.theme.debounce((t) => {
              this.onSortChange(t);
            }, 500)));
        }
        connectedCallback() {
          ((this.container = this.closest("[data-section-id]")),
            (this.sectionId = this.container.dataset.sectionId),
            (this.enableFilters =
              "true" === this.container.dataset.enableFilters),
            (this.enableSorting =
              "true" === this.container.dataset.enableSorting),
            (this.filterMode = this.container.dataset.filterMode),
            (this.collectionHandle = this.container.dataset.collection),
            (this.isSearchPage =
              null != this.container.closest("[data-search-performed]")),
            (this.productGrid = this.container.querySelector(
              "[data-collection-products]",
            )),
            (this.productsCount = this.container.querySelector(
              "[data-products-count]",
            )),
            (this.groupTagFilters = this.container.querySelectorAll(
              "[data-collection-filter]",
            )),
            (this.filters = this.container.querySelector(
              "[data-collection-filters]",
            )),
            (this.filterTriggers = this.container.querySelectorAll(
              "[data-collapsible-trigger]",
            )),
            (this.filtersStickyBar = this.container.querySelector(
              "[data-collection-sticky-bar]",
            )),
            (this.filtersForm = this.container.querySelector(
              "[data-collection-filters-form]",
            )),
            (this.inputSort =
              this.container.querySelectorAll("[data-input-sort]")),
            (this.sortToggle =
              this.container.querySelector("[data-sort-toggle]")),
            (this.collectionSortOptions = this.container.querySelector(
              "[data-collection-sort-options]",
            )),
            (this.ajaxinateItems = this.container.querySelector(
              "ajaxinate-items[data-collection-products]",
            )),
            (this.a11y = window.theme.a11y),
            (this.filterData = []),
            this.filters &&
              ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
              (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
              (this.resizeEvent = window.theme.debounce(() => {
                this.filtersResizeEvents();
              }, 500)),
              this.filtersResizeEvents(),
              document.addEventListener(
                "theme:resize:width",
                this.resizeEvent,
              )),
            this.initTagFilters(),
            this.checkAndRedirectIfNeeded(),
            window.addEventListener("popstate", this.onHistoryChangeBound),
            this.bindToggleButtonsEvents(),
            this.bindFilterButtonsEvents(),
            this.initProductGridEvents(),
            window.theme.setVars(),
            this.sortToggle?.addEventListener("click", this.sortDropdownEvent),
            document.addEventListener("click", this.bodyClickEvent),
            this.filterShowMore());
        }
        checkAndRedirectIfNeeded() {
          console.log('[Filters DEBUG] checkAndRedirectIfNeeded START', { collectionHandle: this.collectionHandle, filterMode: this.filterMode });
          // Check if current URL contains product-type_* with goals-of-usage_*, key-active-ingredients_*, or skin-concerns_* tags
          // If so, redirect to the custom collection URL format
          // But only if the collection exists (we'll check via fetch)
          if (!this.collectionHandle || (this.filterMode !== 'group' && this.filterMode !== 'tag')) {
            console.log('[Filters DEBUG] checkAndRedirectIfNeeded SKIP - wrong mode or no collection');
            return;
          }
          
          const currentPath = window.location.pathname;
          console.log('[Filters DEBUG] checkAndRedirectIfNeeded currentPath:', currentPath);
          const pathParts = currentPath.split('/').filter(part => part !== '');
          
          // Detect language prefix (e.g., /de/, /en/)
          let languagePrefix = '';
          const languageCodes = ['de', 'en', 'fr', 'es', 'it', 'nl', 'pl', 'cs', 'sk', 'hu', 'ro', 'bg', 'hr', 'sl', 'et', 'lv', 'lt', 'mt', 'el', 'pt', 'sv', 'da', 'fi'];
          if (pathParts.length > 0 && languageCodes.includes(pathParts[0])) {
            languagePrefix = '/' + pathParts[0] + '/';
            pathParts.shift(); // Remove language prefix from pathParts
          }
          
          // Check if URL contains tags in format /collections/{collection}/{tags}
          // Examples:
          // /collections/all/product-type_body-lotion+goals-of-usage_hydration
          // /de/collections/all/product-type_body-lotion+goals-of-usage_hydration
          // /collections/all/product-type_body-lotion+key-active-ingredients_hyaluronic-acid
          // /collections/all/product-type_body-cleanser+skin-concerns_dry-skin
          if (pathParts.length >= 3 && pathParts[0] === 'collections') {
            const collectionHandle = pathParts[1];
            const tagsPart = pathParts.slice(2).join('/');
            const tags = tagsPart.split('+');
            console.log('[Filters DEBUG] checkAndRedirectIfNeeded parsed:', { collectionHandle, tagsPart, tags });
            
            const productTypeValues = [];
            const goalsOfUsageValues = [];
            const keyActiveIngredientsValues = [];
            const skinConcernsValues = [];
            
            // Extract values from tags
            for (const tag of tags) {
              if (tag.startsWith('product-type_')) {
                const value = tag.replace('product-type_', '');
                if (value) productTypeValues.push(value);
              } else if (tag.startsWith('goals-of-usage_')) {
                const value = tag.replace('goals-of-usage_', '');
                if (value) goalsOfUsageValues.push(value);
              } else if (tag.startsWith('key-active-ingredients_')) {
                const value = tag.replace('key-active-ingredients_', '');
                if (value) keyActiveIngredientsValues.push(value);
              } else if (tag.startsWith('skin-concerns_')) {
                const value = tag.replace('skin-concerns_', '');
                if (value) skinConcernsValues.push(value);
              }
            }
            
            // Don't redirect when multiple values in same filter group (OR logic - stay on tag URL)
            if (productTypeValues.length > 1 || keyActiveIngredientsValues.length > 1 || goalsOfUsageValues.length > 1 || skinConcernsValues.length > 1) {
              console.log('[Filters DEBUG] checkAndRedirectIfNeeded SKIP REDIRECT - multiple values in same group (OR logic)', {
                productTypeValues,
                keyActiveIngredientsValues,
                goalsOfUsageValues,
                skinConcernsValues
              });
              return;
            }
            
            const productTypeValue = productTypeValues[0] || null;
            const goalsOfUsageValue = goalsOfUsageValues[0] || null;
            const keyActiveIngredientsValue = keyActiveIngredientsValues[0] || null;
            const skinConcernsValue = skinConcernsValues[0] || null;
            
            // Check for product-type + goals-of-usage combination
            if (productTypeValue && goalsOfUsageValue) {
              const customHandle = `${productTypeValue}-${goalsOfUsageValue}`;
              const customUrl = `${languagePrefix}collections/${customHandle}`;
              console.log('[Filters DEBUG] checkAndRedirectIfNeeded product-type+goals-of-usage:', { customHandle, customUrl });
              
              // Only redirect if we're not already on the custom URL
              if (collectionHandle !== customHandle) {
                // Check if collection exists by fetching it
                fetch(customUrl, { method: 'HEAD' })
                  .then((response) => {
                    console.log('[Filters DEBUG] checkAndRedirectIfNeeded fetch goals-of-usage:', { url: customUrl, ok: response.ok });
                    if (response.ok) {
                      // Collection exists, redirect
                      const queryString = window.location.search;
                      const newUrl = customUrl + queryString;
                      console.log('[Filters DEBUG] checkAndRedirectIfNeeded REDIRECTING to:', newUrl);
                      window.location.replace(newUrl);
                    }
                    // If 404, stay on current URL (fallback URL will be used)
                  })
                  .catch((e) => {
                    console.log('[Filters DEBUG] checkAndRedirectIfNeeded fetch error goals-of-usage:', e);
                    // Error fetching, stay on current URL
                  });
                return;
              }
            }
            
            // Check for product-type + key-active-ingredients combination
            if (productTypeValue && keyActiveIngredientsValue) {
              const customHandle = `${productTypeValue}-with-${keyActiveIngredientsValue}`;
              const customUrl = `${languagePrefix}collections/${customHandle}`;
              console.log('[Filters DEBUG] checkAndRedirectIfNeeded product-type+key-active-ingredients:', { customHandle, customUrl });
              
              // Only redirect if we're not already on the custom URL
              if (collectionHandle !== customHandle) {
                // Check if collection exists by fetching it
                fetch(customUrl, { method: 'HEAD' })
                  .then((response) => {
                    console.log('[Filters DEBUG] checkAndRedirectIfNeeded fetch key-active-ingredients:', { url: customUrl, ok: response.ok });
                    if (response.ok) {
                      // Collection exists, redirect
                      const queryString = window.location.search;
                      const newUrl = customUrl + queryString;
                      window.location.replace(newUrl);
                    }
                    // If 404, stay on current URL (fallback URL will be used)
                  })
                  .catch((e) => {
                    console.log('[Filters DEBUG] checkAndRedirectIfNeeded fetch error key-active-ingredients:', e);
                    // Error fetching, stay on current URL
                  });
                return;
              }
            }
            
            // Check for product-type + skin-concerns combination
            if (productTypeValue && skinConcernsValue) {
              // Map common tag values to collection handle values
              const skinConcernsMapping = {
                'aging-loss-of-elasticity': 'aging-skin',
                // Add more mappings as needed
              };
              
              // Try mapped value first, then original value
              const mappedSkinConcern = skinConcernsMapping[skinConcernsValue] || skinConcernsValue;
              const customHandle = `${productTypeValue}-for-${mappedSkinConcern}`;
              const customUrl = `${languagePrefix}collections/${customHandle}`;
              console.log('[Filters DEBUG] checkAndRedirectIfNeeded product-type+skin-concerns:', { customHandle, customUrl });
              
              // Only redirect if we're not already on the custom URL
              if (collectionHandle !== customHandle) {
                // Check if collection exists by fetching it
                fetch(customUrl, { method: 'HEAD' })
                  .then((response) => {
                    if (response.ok) {
                      // Collection exists, redirect
                      const queryString = window.location.search;
                      const newUrl = customUrl + queryString;
                      window.location.replace(newUrl);
                    } else {
                      // If mapped value doesn't work, try original value
                      if (mappedSkinConcern !== skinConcernsValue) {
                        const fallbackHandle = `${productTypeValue}-for-${skinConcernsValue}`;
                        const fallbackUrl = `${languagePrefix}collections/${fallbackHandle}`;
                        return fetch(fallbackUrl, { method: 'HEAD' });
                      }
                    }
                  })
                  .then((response) => {
                    if (response && response.ok) {
                      const fallbackHandle = `${productTypeValue}-for-${skinConcernsValue}`;
                      const fallbackUrl = `${languagePrefix}collections/${fallbackHandle}`;
                      const queryString = window.location.search;
                      const newUrl = fallbackUrl + queryString;
                      window.location.replace(newUrl);
                    }
                  })
                  .catch(() => {
                    // Error fetching, stay on current URL
                  });
                return;
              }
            }
          }
        }
        handleVisibleTooltips() {
          const t = document.querySelector("[data-tooltip-container]");
          t?.classList.contains("is-visible") &&
            t.classList.remove("is-visible");
        }
        updateRange() {
          const t = this.filtersForm.querySelector("[data-se-min-value]"),
            e = this.filtersForm.querySelector("[data-se-max-value]"),
            i = this.filtersForm.querySelector("[data-field-price-min]"),
            s = this.filtersForm.querySelector("[data-field-price-max]");
          if (
            t.hasAttribute("data-se-min-value") &&
            e.hasAttribute("data-se-max-value")
          ) {
            const r = parseFloat(i.placeholder, 10),
              o = parseFloat(s.placeholder, 10),
              n = parseFloat(t.getAttribute("data-se-min-value"), 10),
              a = parseFloat(e.getAttribute("data-se-max-value"), 10);
            (r === n && o === a) ||
              ((i.value = parseInt(n)),
              (s.value = parseInt(a)),
              this.filtersForm.dispatchEvent(
                new Event("input", { bubbles: !0 }),
              ));
          }
        }
        onSubmitHandler(t) {
          t.preventDefault();
          const e = new FormData(this.filtersForm),
            i = new URLSearchParams(e),
            s = [];
          let r = "";
          this.isSearchPage &&
            ((this.searchForm =
              this.container.querySelector("[data-search-form]")),
            (this.currentType =
              this.container.getAttribute("data-current-type")));
          const o = this.filtersForm.querySelector("[data-se-min-value]"),
            n = this.filtersForm.querySelector("[data-se-max-value]"),
            a = this.filtersForm.querySelector("[data-field-price-min]"),
            l = this.filtersForm.querySelector("[data-field-price-max]");
          if (
            o &&
            n &&
            a &&
            l &&
            o.hasAttribute("data-se-min") &&
            n.hasAttribute("data-se-max")
          ) {
            const t = parseFloat(o.getAttribute("data-se-min"), 10),
              e = parseFloat(n.getAttribute("data-se-max"), 10),
              r = a.value ? parseFloat(a.value, 10) : t,
              c = l.value ? parseFloat(l.value, 10) : e;
            r <= t &&
              c >= e &&
              (s.push("filter.v.price.gte"),
              s.push("filter.v.price.lte"),
              i.delete("filter.v.price.gte"),
              i.delete("filter.v.price.lte"));
          }
          if (((r = i.toString()), this.isSearchPage)) {
            r = (function (t, e, i = [], s = !1) {
              const r = new FormData(t),
                o = new URLSearchParams(r);
              if (!e) return o.toString();
              const n = new FormData(e),
                a = new URLSearchParams(n),
                l = [];
              for (const t of r.entries()) "" === t[1] && l.push(t[0]);
              for (const t of n.entries()) "" === t[1] && l.push(t[0]);
              for (let t = 0; t < l.length; t++) {
                const e = l[t];
                (o.has(e) && o.delete(e), a.has(e) && a.delete(e));
              }
              for (const t of o.keys()) a.has(t) && a.delete(t);
              if (i.length > 0)
                for (let t = 0; t < i.length; t++) {
                  const e = i[t];
                  (o.has(e) && o.delete(e), a.has(e) && a.delete(e));
                }
              return (
                s && (a.has("type") && a.delete("type"), o.set("type", s)),
                `${o.toString()}&${a.toString()}`
              );
            })(this.searchForm, this.filtersForm, s);
            let t = "";
            ("all" === this.currentType && (t = "&type=product"),
              r.indexOf("&type=product") > -1 && (t = ""),
              (r += t));
          }
          this.renderSection(r, t);
        }
        onHistoryChange(t) {
          if (!this.filters) return;
          let e = t.state?.searchParams || "";
          if (this.isSearchPage) {
            t.state || (e = window.location.search);
            if (!(e.indexOf("type=product") > -1)) return;
          }
          this.renderSection(e, null, !1);
        }
        renderSection(t, e, i = !0) {
          this.startLoading();
          let s = t;
          if (s) {
            const t = new URLSearchParams(s);
            t.delete("sort_by"), (s = t.toString());
          }
          const r = `${window.location.pathname}?section_id=${this.sectionId}&${s}`,
            o = (t) => t.url === r;
          (this.filterData.some(o)
            ? this.renderSectionFromCache(o, e)
            : this.renderSectionFromFetch(r, e),
            i && this.updateURLHash(s));
        }
        renderSectionFromFetch(t) {
          fetch(t)
            .then((t) => t.text())
            .then((e) => {
              const i = e;
              ((this.filterData = [...this.filterData, { html: i, url: t }]),
                (this.inputSort =
                  this.container.querySelectorAll("[data-input-sort]")),
                this.renderFilters(i),
                this.bindFilterButtonsEvents(),
                this.hideFiltersOnMobile(),
                this.renderProductGrid(i),
                this.updateProductsCount(i),
                this.finishLoading(),
                this.mobileFiltersScrollLock());
            });
        }
        renderSectionFromCache(t, e) {
          const i = this.filterData.find(t).html;
          (this.renderFilters(i, e),
            this.hideFiltersOnMobile(),
            this.renderProductGrid(i),
            this.updateProductsCount(i),
            this.finishLoading(),
            this.mobileFiltersScrollLock());
        }
        renderProductGrid(t) {
          const e = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector("[data-collection-products]");
          e &&
            ((this.productGrid.innerHTML = e.innerHTML),
            this.reInitAjaxinate(e),
            this.initProductGridEvents(),
            this.filterShowMore());
        }
        reInitAjaxinate(t) {
          t.matches("ajaxinate-items") &&
            "function" == typeof this.ajaxinateItems?.reinit &&
            this.ajaxinateItems.reinit();
        }
        initProductGridEvents() {
          (this.handleVisibleTooltips(),
            setTimeout(() => {
              this.finishLoading();
            }, 450));
        }
        updateProductsCount(t) {
          const e = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector("[data-products-count]");
          e && (this.productsCount.innerHTML = e.innerHTML);
        }
        renderFilters(t) {
          const e = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector("[data-collection-filters]");
          e &&
            ((this.filters.innerHTML = e.innerHTML),
            (this.filtersForm = document.querySelector(
              "[data-collection-filters-form]",
            )),
            this.bindFilterButtonsEvents(),
            this.bindToggleButtonsEvents());
        }
        updateURLHash(t) {
          let e = t;
          if (t) {
            const i = new URLSearchParams(t);
            i.delete("sort_by"), (e = i.toString());
          }
          history.pushState(
            { searchParams: e },
            "",
            `${window.location.pathname}${e && "?".concat(e)}`,
          );
        }
        bindFilterButtonsEvents() {
          (this.inputSort.length > 0 &&
            this.inputSort.forEach((t) => {
              t.addEventListener("change", this.updateCollectionFormSortEvent);
            }),
            this.filtersForm &&
              (this.filtersForm.addEventListener(
                "input",
                this.debouncedSubmitEvent.bind(this),
              ),
              this.filtersForm.addEventListener(
                "theme:filter:range-update",
                this.updateRangeEvent,
              )),
            this.collectionSortOptions &&
              this.collectionSortOptions.addEventListener(
                "keyup",
                this.onTabHandlerEvent,
              ),
            "tag" != this.filterMode &&
              "group" != this.filterMode &&
              this.enableFilters &&
              this.container
                .querySelectorAll("[data-filter-reset-button]")
                .forEach((t) => {
                  t.addEventListener("click", this.onFilterResetClick, {
                    once: !0,
                  });
                }));
        }
        onFilterResetClick(t) {
          (t.preventDefault(),
            this.renderSection(
              new URL(t.currentTarget.href).searchParams.toString(),
            ));
        }
        bindToggleButtonsEvents() {
          (this.container
            .querySelectorAll("[data-toggle-filters]")
            .forEach((t) => {
              t.addEventListener("click", this.onFilterToggleClick);
            }),
            this.container
              .querySelectorAll("[data-close-filters]")
              .forEach((t) => {
                t.addEventListener("click", this.hideFiltersDrawer);
              }),
            this.container
              .querySelectorAll("[data-open-filters]")
              .forEach((t) => {
                t.addEventListener("click", this.showFiltersDrawer);
              }),
            this.container
              .querySelector("[data-collection-wrapper]")
              ?.addEventListener("keyup", this.onKeyUpHandler));
        }
        onTabHandler(t) {
          if (
            t.code === theme.keyboardKeys.SPACE ||
            t.code === theme.keyboardKeys.ENTER ||
            t.code === theme.keyboardKeys.NUMPADENTER
          ) {
            const e = t.target.previousElementSibling.value;
            (this.filtersForm
              .querySelectorAll("[data-input-sort]")
              .forEach((t) => {
                (t.checked && (t.checked = !1),
                  t.value === e && (t.checked = !0));
              }),
              this.filtersForm.dispatchEvent(
                new Event("input", { bubbles: !0 }),
              ),
              t.target.dispatchEvent(new Event("click", { bubbles: !0 })));
          }
        }
        onKeyUpHandler(t) {
          t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
        }
        onFilterToggleClick(t) {
          (t.preventDefault(), window.theme.setVars());
          this.filters.classList.contains("collection__filters--visible")
            ? this.hideFiltersDrawer()
            : this.showFiltersDrawer();
        }
        sortDropdownToggle() {
          this.collectionSortOptions &&
            this.collectionSortOptions.classList.toggle(
              "collection__sort__option-wrapper--visible",
            );
        }
        bodyClick(t) {
          if (!this.collectionSortOptions) return;
          const e = this.sortToggle.contains(t.target);
          this.collectionSortOptions.classList.contains(
            "collection__sort__option-wrapper--visible",
          ) &&
            !e &&
            this.sortDropdownToggle();
        }
        updateCollectionFormSort(t) {
          const e = t.target,
            i = e.value,
            s = e.closest("[data-collection-sort-options]");
          (this.container.querySelectorAll("[data-input-sort]").forEach((t) => {
            t.value === i && (t.checked = !0);
          }),
            null !== s &&
              this.filtersForm.dispatchEvent(
                new Event("input", { bubbles: !0 }),
              ));
        }
        showFiltersDrawer() {
          ((this.a11y.state.trigger = document.querySelector(
            "[data-toggle-filters]",
          )),
            this.a11y.trapFocus({ container: this.filters }),
            this.mobileFiltersScrollLock());
        }
        mobileFiltersScrollLock() {
          if (window.innerWidth < theme.sizes.small) {
            const t = document.querySelector("[data-collection-filters-list]");
            (this.filters.classList.contains("collection__filters--visible") ||
              this.filters.classList.add("collection__filters--visible"),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", {
                  bubbles: !0,
                  detail: t,
                }),
              ));
          }
        }
        hideFiltersOnMobile() {
          const t = this.container.querySelectorAll(
            "[data-collapsible-trigger]:not([data-show-more-trigger])",
          );
          window.innerWidth < theme.sizes.small &&
            requestAnimationFrame(() => {
              t.forEach((t) => {
                const e = "true" === t.getAttribute("data-filter-active");
                t.classList.contains("is-expanded") &&
                  !e &&
                  t.dispatchEvent(new Event("click"));
              });
            });
        }
        showFiltersOnDesktop() {
          const t = this.container.querySelectorAll(
              "[data-collapsible-trigger]:not([data-show-more-trigger])",
            ),
            e = this.container.getAttribute("data-filters-default-state"),
            i = "first-open" === e,
            s = "open" === e,
            r = "closed" === e,
            o = this.enableSorting ? 1 : 0;
          t.forEach((t, e) => {
            const n = t.classList.contains("is-expanded"),
              a = "true" === t.getAttribute("data-filter-active"),
              l = a && !n && s;
            (a && !l) ||
              (((r && n) ||
                (i && !n && e === o) ||
                (i && n && e !== o) ||
                (s && !n) ||
                l) &&
                t.dispatchEvent(new Event("click")));
          });
        }
        hideFiltersDrawer() {
          let t = this.filters.classList.contains(
              "collection__filters--visible",
            ),
            e = this.container.classList.contains("is-loading");
          (t &&
            (this.filters.classList.remove("collection__filters--visible"),
            this.a11y.removeTrapFocus()),
            e ||
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", {
                  bubbles: !0,
                  detail: 300,
                }),
              ));
        }
        filtersResizeEvents() {
          window.innerWidth >= theme.sizes.small
            ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer())
            : this.hideFiltersOnMobile();
        }
        filterShowMore() {
          ((this.showMore =
            this.container.querySelectorAll("[data-show-more]")),
            0 !== this.showMore.length &&
              this.showMore.forEach((t) => {
                const e = t.querySelector("[data-collapsible-trigger]"),
                  i = t.querySelector("[data-show-more-actions]");
                if (!i) return;
                const s = i.querySelector("[data-show-more-trigger]"),
                  r = i.querySelector("[data-show-more-container]"),
                  o = r.querySelectorAll(window.theme.focusable);
                ("true" === r.getAttribute("aria-expanded") ||
                  o.forEach((t) => {
                    t.setAttribute("tabindex", "-1");
                  }),
                  s.addEventListener("keyup", (t) => {
                    (t.code !== theme.keyboardKeys.SPACE &&
                      t.code !== theme.keyboardKeys.ENTER &&
                      t.code !== theme.keyboardKeys.NUMPADENTER) ||
                      this.updateShowMoreFocusableElements(t, o);
                  }),
                  s.addEventListener("click", (t) => {
                    this.updateShowMoreFocusableElements(t, o);
                  }),
                  e.addEventListener("keyup", (t) => {
                    (t.code !== theme.keyboardKeys.SPACE &&
                      t.code !== theme.keyboardKeys.ENTER &&
                      t.code !== theme.keyboardKeys.NUMPADENTER) ||
                      this.updateCollapsedContainerFocusableElements(e, s, o);
                  }),
                  e.addEventListener("click", () => {
                    this.updateCollapsedContainerFocusableElements(e, s, o);
                  }));
              }));
        }
        updateCollapsedContainerFocusableElements(t, e, i) {
          requestAnimationFrame(() => {
            const s = "true" === t.getAttribute("aria-expanded"),
              r = "true" === e.getAttribute("aria-expanded");
            i.forEach((t) => {
              (!s && r && t.setAttribute("tabindex", "-1"),
                s && r && t.removeAttribute("tabindex"));
            });
          });
        }
        updateShowMoreFocusableElements(t, e) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const i = "true" === t.target.getAttribute("aria-expanded");
              e.forEach((t, e) => {
                if (i)
                  return (
                    t.removeAttribute("tabindex"),
                    void (0 === e && t.focus())
                  );
                t.setAttribute("tabindex", "-1");
              });
            });
          });
        }
        initTagFilters() {
          console.log('[Filters DEBUG] initTagFilters', { filterMode: this.filterMode, enableFilters: this.enableFilters });
          ("tag" != this.filterMode && "group" != this.filterMode) ||
            !this.enableFilters ||
            ((this.tags = this.container.dataset.tags
              .split("+")
              .filter((t) => t)),
            console.log('[Filters DEBUG] initTagFilters initial tags:', this.tags),
            this.bindFilterTagButtonsEvents(),
            this.bindSortChangeEvent());
        }
        renderTagFiltersProductsOrMerge(t) {
          console.log('[Filters DEBUG] renderTagFiltersProductsOrMerge INPUT:', t);
          if (t && typeof t === 'object' && t.useOrLogic && Array.isArray(t.urls)) {
            console.log('[Filters DEBUG] renderTagFiltersProductsOrMerge -> OR LOGIC path, urls:', t.urls);
            this.renderTagFiltersProductsWithOrLogic(t.urls);
          } else {
            const url = typeof t === 'string' ? t : (t && t.url) || '';
            console.log('[Filters DEBUG] renderTagFiltersProductsOrMerge -> SINGLE URL path:', url);
            if (url) this.renderTagFiltersProducts(url);
          }
        }
        renderTagFiltersProductsWithOrLogic(urls) {
          console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic START, urls:', urls);
          this.startLoading();
          const productIdRegex = /--(\d+)--\d+$/;
          const seenIds = new Set();
          const mergedProductItems = [];
          Promise.all(urls.map((url) => fetch(url).then((r) => (r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`))))))
            .then((responses) => {
              console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic FETCHED', responses.length, 'responses');
              for (let i = 0; i < responses.length; i++) {
                const html = responses[i];
                console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic parsing response', i + 1, 'length:', html?.length);
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const productsEl = doc.querySelector('[data-collection-products]');
                if (!productsEl) {
                  console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic response', i + 1, 'no data-collection-products');
                  continue;
                }
                const items = productsEl.querySelectorAll('[data-product-block]');
                console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic response', i + 1, 'found', items.length, 'product items');
                for (const item of items) {
                  const match = (item.id || '').match(productIdRegex);
                  const productId = match ? match[1] : item.outerHTML.slice(0, 80);
                  if (!seenIds.has(productId)) {
                    seenIds.add(productId);
                    mergedProductItems.push(item.outerHTML);
                  } else {
                    console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic DUPLICATE skipped productId:', productId);
                  }
                }
              }
              console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic MERGED total unique products:', mergedProductItems.length, 'seenIds:', [...seenIds]);
              const firstDoc = new DOMParser().parseFromString(responses[0], 'text/html');
              const firstProductsEl = firstDoc.querySelector('[data-collection-products]');
              const firstFiltersEl = firstDoc.querySelector('[data-collection-filters]');
              console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic first response elements:', {
                hasProductsEl: !!firstProductsEl,
                hasFiltersEl: !!firstFiltersEl
              });
              if (!firstProductsEl || !firstFiltersEl) throw new Error('Required DOM elements not found');
              let grid = firstProductsEl.querySelector('.grid');
              for (const html of responses) {
                if (!grid) {
                  const doc = new DOMParser().parseFromString(html, 'text/html');
                  grid = doc.querySelector('[data-collection-products] .grid');
                }
              }
              let newProductsHtml;
              if (mergedProductItems.length > 0 && grid) {
                const gridOpenTag = grid.outerHTML.match(/<div[^>]*>/)[0];
                const newGridHtml = gridOpenTag + mergedProductItems.join('') + '</div>';
                const noResults = firstProductsEl.querySelector('.collection--no-results');
                console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic building grid:', {
                  hasGrid: !!grid,
                  hasNoResults: !!noResults,
                  gridOpenTagLength: gridOpenTag?.length
                });
                if (noResults) {
                  newProductsHtml = firstProductsEl.innerHTML.replace(noResults.outerHTML, newGridHtml);
                } else {
                  newProductsHtml = firstProductsEl.innerHTML.replace(grid.outerHTML, newGridHtml);
                }
              } else {
                console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic using firstProductsEl as-is (no merge or no grid)');
                newProductsHtml = firstProductsEl.innerHTML;
              }
              console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic updating DOM, newProductsHtml length:', newProductsHtml?.length);
              this.productGrid.innerHTML = newProductsHtml;
              // Don't replace filters - they come from first response which has only ONE tag active.
              // Our filters are already correct (both tags active) from the user's click before fetch.
              // Replacing would overwrite with wrong state and make second filter "disappear".
              if (this.productsCount && mergedProductItems.length > 0) {
                this.productsCount.textContent = this.productsCount.textContent.replace(/\d+/, String(mergedProductItems.length));
              }
              this.alreadyClicked = false;
              this.bindFilterTagButtonsEvents();
              this.bindFilterButtonsEvents();
              this.bindSortChangeEvent();
              this.bindToggleButtonsEvents();
              this.reInitAjaxinate(this.productGrid);
              this.initProductGridEvents();
              this.mobileFiltersScrollLock();
              this.hideFiltersOnMobile();
              this.filterShowMore();
              history.replaceState && window.history.pushState({ path: urls[0] }, '', urls[0]);
              console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic DONE, history updated to:', urls[0]);
            })
            .catch((err) => {
              console.error('[Filters DEBUG] renderTagFiltersProductsWithOrLogic ERROR:', err);
            })
            .finally(() => {
              console.log('[Filters DEBUG] renderTagFiltersProductsWithOrLogic finishLoading');
              this.finishLoading();
            });
        }
        renderTagFiltersProducts(t) {
          console.log('[Filters DEBUG] renderTagFiltersProducts START url:', t);
          if (!t) {
            console.log('[Filters DEBUG] renderTagFiltersProducts SKIP - empty url');
            return;
          }
          (this.startLoading(),
            fetch(t)
              .then((response) => {
                console.log('[Filters DEBUG] renderTagFiltersProducts fetch response:', { url: t, status: response.status, ok: response.ok });
                // Check if response is OK (not 404)
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
              })
              .then((e) => {
                console.log('[Filters DEBUG] renderTagFiltersProducts parsing HTML length:', e?.length);
                const i = e,
                  s = new DOMParser().parseFromString(i, "text/html"),
                  r = s.querySelector("[data-collection-products]"),
                  n = s.querySelector("[data-collection-filters]");
                
                // Check if required elements exist
                if (!r || !n) {
                  console.error('[Filters DEBUG] renderTagFiltersProducts missing elements:', { hasProducts: !!r, hasFilters: !!n });
                  throw new Error("Required DOM elements not found in response");
                }
                
                console.log('[Filters DEBUG] renderTagFiltersProducts SUCCESS, updating DOM');
                const o = r.innerHTML;
                const filtersHtml = n.innerHTML;
                
                ((this.productGrid.innerHTML = o),
                  (this.filters.innerHTML = filtersHtml),
                  (this.inputSort =
                    this.container.querySelectorAll("[data-input-sort]")),
                  (this.filtersForm = document.querySelector(
                    "[data-collection-filters-form]",
                  )),
                  (this.filterData = [...this.filterData, { html: i, url: t }]),
                  (this.alreadyClicked = !1),
                  this.bindFilterTagButtonsEvents(),
                  this.bindFilterButtonsEvents(),
                  this.bindSortChangeEvent(),
                  this.bindToggleButtonsEvents(),
                  this.reInitAjaxinate(r),
                  this.initProductGridEvents(),
                  this.updateProductsCount(i),
                  this.mobileFiltersScrollLock(),
                  this.hideFiltersOnMobile(),
                  this.filterShowMore(),
                  history.replaceState &&
                    window.history.pushState({ path: t }, "", t));
              })
              .catch((error) => {
                console.error('[Filters DEBUG] renderTagFiltersProducts ERROR:', error);
                this.finishLoading();
                
                // If custom URL failed and we have a fallback, try it
                if (this.lastFallbackUrl && t !== this.lastFallbackUrl) {
                  console.log('[Filters DEBUG] renderTagFiltersProducts trying fallback URL:', this.lastFallbackUrl);
                  this.renderTagFiltersProductsOrMerge(this.lastFallbackUrl);
                  this.lastFallbackUrl = null;
                } else {
                  // Show error message or reload page
                  console.error("Failed to load collection filters. Please try again.");
                  // Optionally reload the page to reset state
                  // window.location.reload();
                }
              }));
        }
        bindFilterTagButtonsEvents() {
          (this.container
            .querySelectorAll("[data-collection-filter-tag-button]")
            .forEach((t) => {
              t.addEventListener(
                "click",
                this.onFilterTagButtonClick.bind(this),
              );
            }),
            this.container
              .querySelectorAll("[data-filter-tag-reset-button]")
              .forEach((t) => {
                t.addEventListener("click", this.onFilterTagClearClick);
              }),
            this.container
              .querySelectorAll("[data-filter-reset-button]")
              .forEach((t) => {
                t.addEventListener("click", this.onFilterTagResetClick);
              }));
        }
        bindSortChangeEvent() {
          this.container.querySelectorAll("[data-input-sort]").forEach((t) => {
            t.addEventListener("input", this.debouncedSortEvent.bind(this));
          });
        }
        onFilterTagButtonClick(t) {
          if ((t.preventDefault(), this.alreadyClicked)) return;
          this.alreadyClicked = !0;
          const e = t.currentTarget,
            i = e.dataset.tag;
          console.log('[Filters DEBUG] onFilterTagButtonClick tag:', i, 'was active:', e.parentNode.classList.contains("is-active"));
          if (e.parentNode.classList.contains("is-active")) {
            let t = this.tags.indexOf(i);
            (e.parentNode.classList.remove("is-active"),
              t > -1 && this.tags.splice(t, 1));
          } else (e.parentNode.classList.add("is-active"), this.tags.push(i));
          console.log('[Filters DEBUG] onFilterTagButtonClick tags after:', this.tags);
          const s = this.buildTagUrl();
          (this.container
            .querySelector("[data-collection-filter]")
            .classList.remove("is-expanded"),
            this.container
              .querySelector("[data-collection-filter]")
              .setAttribute("aria-expanded", !1),
            this.container.setAttribute("data-tags", "[" + this.tags + "]"),
            this.renderTagFiltersProductsOrMerge(s));
        }
        onFilterTagClearClick(t) {
          if ((t.preventDefault(), this.alreadyClicked)) return;
          this.alreadyClicked = !0;
          const e = t.currentTarget.dataset.tag,
            i = this.tags.indexOf(e);
          console.log('[Filters DEBUG] onFilterTagClearClick removing tag:', e, 'index:', i);
          i > -1 && this.tags.splice(i, 1);
          console.log('[Filters DEBUG] onFilterTagClearClick tags after:', this.tags);
          const s = this.buildTagUrl();
          (this.container.setAttribute("data-tags", "[" + this.tags + "]"),
            this.renderTagFiltersProductsOrMerge(s));
        }
        onSortChange() {
          console.log('[Filters DEBUG] onSortChange');
          const t = this.buildTagUrl(!0);
          this.renderTagFiltersProductsOrMerge(t);
        }
        getSortValue() {
          let t = "";
          return (
            this.inputSort.forEach((e) => {
              e.checked && (t = e.value);
            }),
            t
          );
        }
        buildTagUrl(t = !1) {
          console.log('[Filters DEBUG] buildTagUrl START', { includeSort: t, tags: this.tags });
          // Custom URL formats:
          // 1. /collections/{product-type}-{goals-of-usage} (for product-type + goals-of-usage)
          // 2. /collections/{product-type}-with-{key-active-ingredients} (for product-type + key-active-ingredients)
          // 3. /collections/{product-type}-for-{skin-concerns} (for product-type + skin-concerns)
          // Apply for any collection if tags match these patterns
          // Only use custom URL if the collection exists (checked via fetch)
          // Preserve language prefix (e.g., /de/) if present
          const currentPath = window.location.pathname;
          const pathParts = currentPath.split('/').filter(part => part !== '');
          const languageCodes = ['de', 'en', 'fr', 'es', 'it', 'nl', 'pl', 'cs', 'sk', 'hu', 'ro', 'bg', 'hr', 'sl', 'et', 'lv', 'lt', 'mt', 'el', 'pt', 'sv', 'da', 'fi'];
          let languagePrefix = '';
          if (pathParts.length > 0 && languageCodes.includes(pathParts[0])) {
            languagePrefix = '/' + pathParts[0] + '/';
          }
          
          if (this.tags.length > 0) {
            const productTypeValues = [];
            const goalsOfUsageValues = [];
            const keyActiveIngredientsValues = [];
            const skinConcernsValues = [];
            
            // Extract values after underscore from tags (support multiple per group)
            for (const tag of this.tags) {
              if (tag.startsWith('product-type_')) {
                const value = tag.replace('product-type_', '');
                if (value) productTypeValues.push(value);
              } else if (tag.startsWith('goals-of-usage_')) {
                const value = tag.replace('goals-of-usage_', '');
                if (value) goalsOfUsageValues.push(value);
              } else if (tag.startsWith('key-active-ingredients_')) {
                const value = tag.replace('key-active-ingredients_', '');
                if (value) keyActiveIngredientsValues.push(value);
              } else if (tag.startsWith('skin-concerns_')) {
                const value = tag.replace('skin-concerns_', '');
                if (value) skinConcernsValues.push(value);
              }
            }
            
            const productTypeValue = productTypeValues[0] || null;
            const goalsOfUsageValue = goalsOfUsageValues[0] || null;
            const keyActiveIngredientsValue = keyActiveIngredientsValues[0] || null;
            const skinConcernsValue = skinConcernsValues[0] || null;
            console.log('[Filters DEBUG] buildTagUrl parsed:', {
              productTypeValues,
              productTypeValue,
              goalsOfUsageValues,
              keyActiveIngredientsValues,
              skinConcernsValues,
              goalsOfUsageValue,
              keyActiveIngredientsValue,
              skinConcernsValue
            });
            
            // OR logic: when multiple values in same filter group, fetch each and merge to avoid zero results
            const orGroupValues = productTypeValues.length > 1 ? productTypeValues
              : keyActiveIngredientsValues.length > 1 ? keyActiveIngredientsValues
              : goalsOfUsageValues.length > 1 ? goalsOfUsageValues
              : skinConcernsValues.length > 1 ? skinConcernsValues
              : null;
            
            if (orGroupValues) {
              const orGroupPrefix = productTypeValues.length > 1 ? 'product-type_'
                : keyActiveIngredientsValues.length > 1 ? 'key-active-ingredients_'
                : goalsOfUsageValues.length > 1 ? 'goals-of-usage_'
                : 'skin-concerns_';
              const baseTags = this.tags.filter(tag => !tag.startsWith(orGroupPrefix));
              const urls = orGroupValues.map(val => {
                const tagsForUrl = [...baseTags, orGroupPrefix + val];
                return this.buildUrlFromTags(tagsForUrl, t);
              });
              console.log('[Filters DEBUG] buildTagUrl OR LOGIC:', { orGroupPrefix, orGroupValues, baseTags, urls });
              return { urls, useOrLogic: true };
            }
            
            // Check for product-type + goals-of-usage combination (single value only)
            if (productTypeValue && goalsOfUsageValue) {
              const customHandle = `${productTypeValue}-${goalsOfUsageValue}`;
              let customUrl = `${languagePrefix}collections/${customHandle}`;
              console.log('[Filters DEBUG] buildTagUrl custom product-type+goals-of-usage:', customUrl);
              
              if (t) {
                const sortValue = this.getSortValue();
                sortValue && (customUrl += `${customUrl.includes("?") ? "&" : "?"}sort_by=${sortValue}`);
              }
              
              // Store fallback URL in case custom collection doesn't exist
              const fallbackUrl = this.buildDefaultTagUrl(t);
              this.lastFallbackUrl = fallbackUrl;
              console.log('[Filters DEBUG] buildTagUrl RETURN custom goals-of-usage, fallback:', fallbackUrl);
              return customUrl;
            }
            
            // Check for product-type + key-active-ingredients combination
            if (productTypeValue && keyActiveIngredientsValue) {
              const customHandle = `${productTypeValue}-with-${keyActiveIngredientsValue}`;
              let customUrl = `${languagePrefix}collections/${customHandle}`;
              console.log('[Filters DEBUG] buildTagUrl custom product-type+key-active-ingredients:', customUrl);
              
              if (t) {
                const sortValue = this.getSortValue();
                sortValue && (customUrl += `${customUrl.includes("?") ? "&" : "?"}sort_by=${sortValue}`);
              }
              
              // Store fallback URL in case custom collection doesn't exist
              const fallbackUrl = this.buildDefaultTagUrl(t);
              this.lastFallbackUrl = fallbackUrl;
              console.log('[Filters DEBUG] buildTagUrl RETURN custom key-active-ingredients, fallback:', fallbackUrl);
              return customUrl;
            }
            
            // Check for product-type + skin-concerns combination
            if (productTypeValue && skinConcernsValue) {
              // Try different variations of skin concerns value
              // Map common tag values to collection handle values
              const skinConcernsMapping = {
                'aging-loss-of-elasticity': 'aging-skin',
                // Add more mappings as needed
              };
              
              // Try mapped value first, then original value
              const mappedSkinConcern = skinConcernsMapping[skinConcernsValue] || skinConcernsValue;
              const customHandle = `${productTypeValue}-for-${mappedSkinConcern}`;
              let customUrl = `${languagePrefix}collections/${customHandle}`;
              console.log('[Filters DEBUG] buildTagUrl custom product-type+skin-concerns:', customUrl);
              
              if (t) {
                const sortValue = this.getSortValue();
                sortValue && (customUrl += `${customUrl.includes("?") ? "&" : "?"}sort_by=${sortValue}`);
              }
              
              // Store fallback URL in case custom collection doesn't exist
              const fallbackUrl = this.buildDefaultTagUrl(t);
              this.lastFallbackUrl = fallbackUrl;
              console.log('[Filters DEBUG] buildTagUrl RETURN custom skin-concerns, fallback:', fallbackUrl);
              return customUrl;
            }
          }
          
          // Default behavior for other cases
          const defaultUrl = this.buildDefaultTagUrl(t);
          console.log('[Filters DEBUG] buildTagUrl RETURN default:', defaultUrl);
          return defaultUrl;
        }
        buildUrlFromTags(tags, includeSort = false) {
          console.log('[Filters DEBUG] buildUrlFromTags INPUT:', { tags, includeSort });
          const currentPath = window.location.pathname;
          const pathParts = currentPath.split('/').filter(part => part !== '');
          const languageCodes = ['de', 'en', 'fr', 'es', 'it', 'nl', 'pl', 'cs', 'sk', 'hu', 'ro', 'bg', 'hr', 'sl', 'et', 'lv', 'lt', 'mt', 'el', 'pt', 'sv', 'da', 'fi'];
          let languagePrefix = '';
          if (pathParts.length > 0 && languageCodes.includes(pathParts[0])) {
            languagePrefix = '/' + pathParts[0] + '/';
          }
          let collectionHandle = this.collectionHandle;
          if (collectionHandle && !collectionHandle.startsWith('/')) {
            collectionHandle = '/' + collectionHandle;
          }
          if (collectionHandle && languagePrefix && collectionHandle.startsWith(languagePrefix)) {
            languagePrefix = '';
          }
          const tagsPart = tags.length > 0 ? `/${tags.join("+")}` : "/";
          let url = `${languagePrefix}${collectionHandle}${tagsPart}`;
          if (includeSort) {
            const sortValue = this.getSortValue();
            sortValue && (url += `${url.includes("?") ? "&" : "?"}sort_by=${sortValue}`);
          }
          console.log('[Filters DEBUG] buildUrlFromTags OUTPUT:', url);
          return url;
        }
        buildDefaultTagUrl(t = !1) {
          return this.buildUrlFromTags(this.tags, t);
        }
        onFilterTagResetClick(t) {
          if ((t?.preventDefault(), this.alreadyClicked)) return;
          console.log('[Filters DEBUG] onFilterTagResetClick - resetting all filters');
          ((this.alreadyClicked = !0),
            this.container
              .querySelectorAll("[data-collection-filter-tag]")
              .forEach((t) => {
                t.classList.remove("is-active");
              }),
            this.container
              .querySelectorAll("[data-collection-filter]")
              .forEach((t) => {
                (t.classList.remove("is-expanded"),
                  t.setAttribute("aria-expanded", !1));
              }),
            (this.tags = []),
            this.container.setAttribute("data-tags", ""));
          const e = this.buildTagUrl();
          this.renderTagFiltersProductsOrMerge(e);
        }
        getProductsOffsetTop() {
          return (
            this.productGrid.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            this.filtersStickyBar.offsetHeight
          );
        }
        getStickyBarOffsetTop() {
          return (
            this.filtersStickyBar.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top
          );
        }
        startLoading() {
          (this.container.classList.add("is-loading"),
            window.innerWidth >= theme.sizes.small &&
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", { bubbles: !0 }),
              ));
          let t = this.getProductsOffsetTop();
          window.scrollTo({ top: t, left: 0, behavior: "smooth" });
        }
        finishLoading() {
          const t = document.querySelectorAll(
              '[data-section-type="popups"] .popup--visible',
            ),
            e = t.length > 0;
          if ((this.container.classList.remove("is-loading"), e)) {
            let e = 0;
            ([...t].forEach((t) => {
              t.hasAttribute("data-prevent-scroll-lock") && (e += 1);
            }),
              e === t.length &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0,
                    detail: 300,
                  }),
                ));
          } else
            window.innerWidth >= theme.sizes.small &&
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", {
                  bubbles: !0,
                  detail: 300,
                }),
              );
        }
        disconnectedCallback() {
          (this.filters &&
            document.removeEventListener(
              "theme:resize:width",
              this.resizeEvent,
            ),
            window.removeEventListener("popstate", this.onHistoryChangeBound),
            document.removeEventListener("click", this.bodyClickEvent),
            this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
            this.finishLoading());
        }
      },
    );
})();
